import { useReimbursementRequestContext } from "../../../Contexts/ReimbursementRequestContext";
import CustomizedProgressBars from "../../../Components/LinearDeterminate";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import { removeDuplicatesByField } from "../../../utilities/helper";
import CancelReimbursementModal from "../CancelReimbursementModal";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import * as ScrollArea from "@radix-ui/react-scroll-area";
import { ScrollBar } from "../../../Components/ScrollBar";
import { useAuth } from "../../../Contexts/AuthContext";
import { CircularProgress } from "@mui/material";
import Button from "../../../Components/Button";
import RequestForm from "./RequestForm";
import ClaimType from "./ClaimType";
import Policies from "./Policies";
import { useEffect } from "react";
import Summary from "./Summary";
import Success from "./Success";
import Upload from "./Upload";
import apiRequest from "../../../utilities/request";
import { baseUrl } from "../../../utilities/configurations";
import dayjs from "dayjs";

function Index() {
  const {
    setDisplayAlert,
    setCurrentStep,
    setAllDoctors,
    displayAlert,
    setLoadState,
    currentStep,
    errorField,
    loadState,
    navigate,
    formData,
  } = useReimbursementRequestContext();

  const { physicians } = useAuth();

  useEffect(() => {
    const uniqueData = removeDuplicatesByField(physicians, "Physician");
    setAllDoctors(uniqueData);
  }, [physicians]);

  const calculateProgress = () => {
    let totalStep = 5;
    return (currentStep / totalStep) * 100;
  };

  const handleNext = () => {
    if (currentStep === 1) {
      validateStepOne();
    } else if (currentStep === 2) {
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 3) {
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 4) {
      setCurrentStep(currentStep + 1);
    } else if (currentStep === 5) {
      submitRequest();
    }
  };

  const validateStepOne = () => {
    setCurrentStep(currentStep + 1);
  };

  const submitRequest = async() => {
    const policy = formData.selectedPolicy;
    try {
      setLoadState("submit");
      const res = await apiRequest(`${baseUrl}/Reimbursement/GenerateLoe`,"POST",{
        "policyNo": policy.policyNo,
        "claimAmount": parseFloat(formData.claimAmount),
        "physician": formData.doctor.Physician?.split(":")[1].trim() || "",
        "dischargeDate": "2024-09-10T08:52:06.541Z",
        "cardNo": policy.cardNo,
        "providerCode": formData.hospital.providerCode,
        "coverage": formData.claimType,
        "availmentDate": dayjs(formData.availmentDate),
        "createdBy": `${policy.firstName} ${policy.middleName} ${policy.lastName} ${policy.suffixName}`,
        "claimType": formData.claimType,
        "loaType": ""
      })
      if(!res.error){
        console.log(res);
        //proceed to next api
      }
    } catch (error) {
      setLoadState("submit failed");
      console.log(error)
    }
  };

  const handlePrev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleBackToDashboard = () => {
    navigate("/home", { replace: true });
  };

  const handleCancelRequest = () => {
    navigate(-1);
    setDisplayAlert(false);
  };

  const validateRequiredUploads = () => {
    let requiredFields =
      formData.chargeSlip !== null && formData.officialReceipt !== null;
    if (formData.claimType === "Out Patient (OP)") {
      requiredFields =
        requiredFields &&
        formData.medicalCertificate !== null &&
        formData.policeReport !== null;
    } else if (formData.claimType === "In Patient (IP)") {
      requiredFields =
        requiredFields &&
        formData.medicalCertificate !== null &&
        formData.statementOfAccount !== null &&
        formData.policeReport !== null;
    } else if (formData.claimType === "OP Medicine") {
      requiredFields =
        requiredFields && formData.opMedicinePrescription !== null;
    } else if (formData.claimType === "Optical") {
      requiredFields = requiredFields && formData.opticalPrescription !== null;
    } else if (formData.claimType === "Dental") {
      requiredFields = requiredFields && formData.dentalCertificate !== null;
    }
    return requiredFields;
  };

  const getNextButtonClassName=()=>{
    let str = "h-12 w-full transition ease-in-out delay-75 rounded-xl bg-[#0947AB] text-white"
    if(isButtonDisabled){
      str = "h-12 w-full transition ease-in-out delay-75 rounded-xl bg-[#F6F7F7] text-gray-400"
    }
    return str;
  }

  const getProgressbarClassName=()=>{
    let str = "";
    if(loadState === "submit success"){
      str = "invisible";
    }
    return str;
  }

  let backButton = (
    <button disabled>
      <KeyboardArrowLeft className="invisible" />
    </button>
  );

  if (currentStep >= 2 && currentStep <= 5) {
    backButton = (
      <button onClick={handlePrev}>
        <KeyboardArrowLeft />
      </button>
    );
  }

  let closeButton = (
    <button onClick={() => setDisplayAlert(true)}>
      <CloseOutlinedIcon />
    </button>
  );

  let buttonTxt = "Continue";
  if (currentStep === 5) {
    buttonTxt = "Submit request";
  }

  const isButtonDisabled =
    loadState === "submit" ||
    (currentStep === 4 && !validateRequiredUploads()) ||
    errorField !== "" ||
    (currentStep === 5 && !formData.termsChecked) ||
    !formData.selectedPolicy;

  let nextButton = (
    <Button
      disabled={isButtonDisabled}
      className={getNextButtonClassName()}
      onClick={handleNext}
    >
      {loadState === "submit" ? <CircularProgress size={"1rem"} /> : buttonTxt}
    </Button>
  );

  let content = null;
  if (currentStep === 1) {
    content = <Policies />;
  } else if (currentStep === 2) {
    nextButton = null;
    content = <ClaimType nextStep={handleNext} />;
  } else if (currentStep === 3) {
    content = <RequestForm />;
  } else if (currentStep === 4) {
    content = <Upload />;
  } else if (currentStep === 5) {
    content = <Summary />;
  }

  if (loadState === "submit success") {
    closeButton = null;
    backButton = null;

    nextButton = (
      <Button
        className={`h-12 w-full transition ease-in-out delay-75 rounded-xl bg-[#0947AB] text-white`}
        onClick={handleBackToDashboard}
      >
        Go back to dashboard
      </Button>
    );

    content = <Success />;
  }

  return (
    <div className="flex flex-col min-h-screen sm:items-center sm:bg-[#E7EEFA]">
      <div className="flex flex-col flex-1 sm:flex-none bg-white sm:w-148 sm:items-center rounded-xl sm:my-24">
        <div className="w-full">
          <div className="flex flex-row items-center p-3 border-b">
            {backButton}
            <div className="text-center text-md font-bold flex-1">
              Reimbursement request
            </div>
            {closeButton}
          </div>
          <div className="p-3">
            <CustomizedProgressBars
              className={getProgressbarClassName()}
              value={calculateProgress()}
            />
          </div>
        </div>
        <ScrollArea.Root className="w-full rounded overflow-hidden">
          <ScrollArea.Viewport
            id="scrollDiv"
            style={{ scrollBehavior: "smooth" }}
            className="w-full min-h-[200px] h-[calc(100vh-165px)] sm:h-full rounded"
          >
            {content}
          </ScrollArea.Viewport>
          <ScrollBar />
        </ScrollArea.Root>
        <div className="flex w-full p-4 mt-auto">{nextButton}</div>
      </div>
      <CancelReimbursementModal
        open={displayAlert}
        onClose={() => setDisplayAlert(false)}
        onCancel={handleCancelRequest}
      />
    </div>
  );
}

export default Index;
